/* eslint-disable no-unused-vars */
import apiClient from '@u/apiClient'
import { helper } from '@u/helper'
import GetListDocumentController from '@/wayfinder/actions/App/Http/Controllers/Document/GetListDocumentController'
import GetWikiSharedDocListController from '@/wayfinder/actions/App/Http/Controllers/WikiSharedDoc/GetWikiSharedDocListController'
import GetDocumentByIdController from '@/wayfinder/actions/App/Http/Controllers/Document/GetDocumentByIdController'
import GetDocumentEditorController from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/GetDocumentEditorController'
import GetNewDocumentEditorController from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/GetNewDocumentEditorController'
import GetDocumentEditorPreviewV3Controller from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/GetDocumentEditorPreviewV3Controller'
import MigrateLocalDocumentToDocumentLibraryController from '@/wayfinder/actions/App/Http/Controllers/Document/MigrateLocalDocumentToDocumentLibraryController'
import MigrateLibraryDocumentToDocumentLocalController from '@/wayfinder/actions/App/Http/Controllers/Document/MigrateLibraryDocumentToDocumentLocalController'
import DuplicateDocumentAsV3Controller from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/DuplicateDocumentAsV3Controller'
import DuplicateDocumentV3Controller from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/DuplicateDocumentV3Controller'
import StoreDocumentEditorController from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/StoreDocumentEditorController'
import UpdateDocumentEditorController from '@/wayfinder/actions/App/Http/Controllers/Document/Editor/UpdateDocumentEditorController'
import GetDocumentDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Document/GetDocumentDossierByIdController'
import AddDocumentByDossierIdToEnveloppeController from '@/wayfinder/actions/App/Http/Controllers/Dossier/AddDocumentByDossierIdToEnveloppeController'
import GetDocumentActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Document/GetDocumentActivitiesByIdController'
import FetchDocumentHeadersController from '@/wayfinder/actions/App/Http/Controllers/Document/FetchDocumentHeadersController'
import StoreDocumentController from '@/wayfinder/actions/App/Http/Controllers/Document/StoreDocumentController'
import AddWikiSharedDocToDocumentsController from '@/wayfinder/actions/App/Http/Controllers/Document/AddWikiSharedDocToDocumentsController'
import UpdateDocumentOrderController from '@/wayfinder/actions/App/Http/Controllers/Document/UpdateDocumentOrderController'
import DeleteDocumentByIdController from '@/wayfinder/actions/App/Http/Controllers/Document/DeleteDocumentByIdController'
import DeleteWikiSharedDocumentByIdController from '@/wayfinder/actions/App/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController'
import DocumentPreviewDeleteController from '@/wayfinder/actions/App/Http/Controllers/Document/DocumentPreviewDeleteController'
import DocumentPreviewReplaceController from '@/wayfinder/actions/App/Http/Controllers/Document/DocumentPreviewReplaceController'
import { apiPath } from '@u/apiPath'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import UpdateDocumentController from '@/wayfinder/actions/App/Http/Controllers/Document/UpdateDocumentController'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

function errorSuccessCallback(payload) {
  if (payload.errorCallback) {
    payload.errorCallback()
  }
}

function initDocumentForm(document) {
  if (document.form) {
    document.form.forEach((it, key) => {
      // Disable the rewrite form name
      it.saved = true
      it.valid = true

      if (it.options) {
        it.options.forEach((opt) => {
          // Disable the rewrite form name
          opt.saved = true
          opt.valid = true
        })
      }
    })
  }

  return document
}

const base_errors = {}

export default {
  // region fetch

  fetchTenantDocumentsList: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetListDocumentController['/api/document'].get())
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchWikiSharedDocumentsList: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetWikiSharedDocListController.get())
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchDocumentById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDocumentByIdController.get({ document: payload.document_id }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchDocumentEditor: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDocumentEditorController.get({
            type: payload.document_type,
            document: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewDocumentEditor: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetNewDocumentEditorController.get({ type: payload.document_type }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchDocumentPreviewV3: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDocumentEditorPreviewV3Controller.post({
            type: payload.document_type,
            document: payload.document_id,
            dossier: payload.dossier_id
          }),
          {
            stringContent:
              typeof payload.stringContent === 'boolean'
                ? payload.stringContent
                : true,
            ...payload.data
          },
          {
            responseType: 'blob',
            headers: {
              Accept: 'application/pdf'
            },
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  copyLocalToLibrary: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          MigrateLocalDocumentToDocumentLibraryController.put({
            document: payload.document_id
          }),
          payload.form
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  copyLibraryToLocal: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          MigrateLibraryDocumentToDocumentLocalController.put({
            document: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  duplicateDocumentAsV3: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DuplicateDocumentAsV3Controller.post({
            type: 'document',
            document: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  duplicateDocument: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DuplicateDocumentV3Controller.post({
            type: payload.type,
            document: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  duplicateWikiDocument: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DuplicateDocumentV3Controller.post({
            type: 'wikishareddoc',
            document: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeDocumentFromDocumentEditor: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('document', JSON.stringify(payload.params))

      if (payload.model_file) {
        helper.toFormData(
          {
            model_file: payload.model_file
          },
          null,
          formData
        )
      }

      apiClient
        .route(
          StoreDocumentEditorController.post({ type: payload.document_type }),
          formData
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateDocumentFromDocumentEditor: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDocumentEditorController.put({
            type: payload.document_type,
            document: payload.document_id
          }),
          {
            document: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async fetchDocument({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetDocumentByIdController.get({ document: payload.document_id }))
      .then(async (response) => {
        await commit('setDocument', initDocumentForm(response.data.document))
      })
      .catch(async (reason) => {
        console.error('fetchDocument', reason)
      })
  },
  fetchDocumentDossier: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDocumentDossierByIdController.get({
            dossier: payload.dossier_id,
            type: payload.document_type,
            document_id: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addDocumentDossierToEnveloppe: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddDocumentByDossierIdToEnveloppeController.post({
            dossier: payload.dossier_id,
            type: payload.document_type,
            document_id: payload.document_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async fetchNewDocument({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'document' } }))
      .then(async (response) => {
        await commit('setDocument', initDocumentForm(response.data.document))
      })
      .catch(async (reason) => {
        console.error('fetchDocument', reason)
      })
  },

  fetchDocumentActivitiesByDocumentID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDocumentActivitiesByIdController.get({
            document: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchDocumentHeadersList({ commit }) {
    await apiClient
      .route(FetchDocumentHeadersController.get())
      .then(async (response) => {
        await commit('setDocumentsHeaders', response.data.headers)
      })
      .catch(async (reason) => {
        await console.error('fetchContactDossierList', reason)
      })
  },
  // endregion

  // region store
  async storeDocument({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    let formData = new FormData()

    const { template, ...documentForJson } = payload.document
    formData.append('data', JSON.stringify(documentForJson))

    if (template) {
      formData.append('template', template)
    }

    await apiClient
      .route(StoreDocumentController.post(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
          // await commit('setDocument', response.data.document)
          processSuccessCallback(payload)
        } else {
          errorSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('storeDocument', reason)

        errorSuccessCallback(payload)
      })
  },

  addWikiSharedDocToDocumentList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(AddWikiSharedDocToDocumentsController.post(), payload)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  async updateDocument({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    let formData = new FormData()
    const { template, ...documentForJson } = payload.document
    formData.append('data', JSON.stringify(documentForJson))

    if (template) {
      formData.append('template', template)
    }
    await apiClient
      .formRoute(
        UpdateDocumentController.put({ document: payload.document_id }),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      .then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
          await commit('setDocument', initDocumentForm(response.data.document))
          processSuccessCallback(payload)
        } else {
          errorSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('updateDocument', reason)

        errorSuccessCallback(payload)
      })
  },
  updateDocumentOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('auth/setErrors', base_errors, { root: true })
      apiClient
        .route(UpdateDocumentOrderController.put(), payload)
        .then(async (response) => {
          if (response.status === 201) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          console.error('updateDocumentOrder', reason)
        })
    })
  },
  // endregion

  // region attachment
  async saveDocumentAsAttachment({ commit }, payload) {
    await apiClient
      .get(apiPath(`${payload.url}`))
      .then(async (response) => {
        if (payload.successCallback) {
          payload.successCallback()
        }
      })
      .catch(async (reason) => {
        console.error('saveDocumentAsAttachment', reason)
      })
  },
  // endregion

  // region delete
  deleteDocumentById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteDocumentByIdController.delete.delete({ document: payload.id })
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  deleteWikiSharedDocumentById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteWikiSharedDocumentByIdController.delete.delete({
            wiki_shared_doc: payload.id
          })
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteDocumentById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteDocumentByIdController.undo.get({ id: payload.id }))
        .then(async (response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  undoDeleteWikiSharedDocById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteWikiSharedDocumentByIdController.undo.get({ id: payload.id })
        )
        .then(async (response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  processDeletePreviewDocumentEditorAction: async ({ commit }, payload) => {
    const { doc_type, doc_id, media_id } = payload

    return apiClient
      .route(
        DocumentPreviewDeleteController.delete({
          type: doc_type,
          document: doc_id,
          file_id: media_id
        })
      )
      .then((res) => {
        if (res?.data) {
          return res.data
        }

        return { success: false }
      })
  },

  processReplacePreviewDocumentEditorAction: async ({ commit }, payload) => {
    const { doc_type, doc_id, media_id, file } = payload

    const data = new FormData()

    data.append('new_file', file)

    return apiClient
      .route(
        DocumentPreviewReplaceController.post({
          type: doc_type,
          document: doc_id,
          file_id: media_id
        }),
        data
      )
      .then((res) => {
        if (res?.data) {
          return res.data
        }

        return { success: false }
      })
  }
  // endregion
}
